import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import MainNav from "./Components/MainNav";
import About from "./Pages/ABOUT";
import Account from "./Pages/ACCOUNT";
import ORDER from "./Pages/ORDER";
import PAYHERE from "./Pages/PAYHERE";
import PREVIEW from "./Pages/PREVIEW";
import Signin from "./Pages/SIGNIN";
import Signup from "./Pages/SIGNUP";
import STORE from "./Pages/STORE";
import {useAuthState} from 'react-firebase-hooks/auth'
import { auth } from "./firebase";
import { useEffect } from "react";




function App() {
  const [user,loading,error] = useAuthState(auth)
  useEffect(()=>{
    if(error){
      console.log(error);
      alert(
        "Something happened while fetching data. If this happens continuesly please contact us. Redirecting..."
      );
    }
  },[error])
  return (
    <div className="w-full text-black bg-gray ">
      <div className="w-full max-w-6xl bg-white shadow-xl px-page mx-auto  h-screen flex flex-col">
        <BrowserRouter>
          <MainNav uid={user ? user.uid  :''}/>
          <Switch>
            <Route path="/" exact>
              <STORE />
            </Route>
            <Route path="/user" exact>
              {user ? <Account uid={user ? user.uid  :''} /> : <Redirect to="/sign-in" />}
            </Route>
            <Route path="/about" exact>
              <About />
            </Route>
            <Route path="/web/:id" exact>
              <ORDER />
            </Route>
            <Route path="/sign-in" exact>
              <Signin uid={user ? user.uid  :''}/>
            </Route>
            <Route path="/sign-up" exact>
              <Signup />
            </Route>
            <Route path="/preview/:link" exact>
              <PREVIEW />
            </Route>
            <Route path="/order/:id" exact>
              {user ? <PAYHERE uid={user ? user.uid  :''}/> : <Redirect to="/sign-in" />}
            </Route>
          </Switch>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
